import { chamadaRemovida } from '../config/api';

export const getAtivos = async () => {
  const response = await chamadaRemovida();
  return response.data;
};

export const createAtivos = async (ativos) => {
  const response = await chamadaRemovida();
  return response.data;
};

export const updateAtivos = async (id, transaction) => {
  const response = await chamadaRemovida();
  return response.data;
};

export const deleteAtivos = async (id) => {
  const response = await chamadaRemovida();
  return response.data;
};
